import { render, staticRenderFns } from "./feature-card.vue?vue&type=template&id=5700e4a0&scoped=true"
import script from "./feature-card.vue?vue&type=script&lang=js"
export * from "./feature-card.vue?vue&type=script&lang=js"
import style0 from "./feature-card.vue?vue&type=style&index=0&id=5700e4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5700e4a0",
  null
  
)

export default component.exports